import { useEffect } from "react";
import Lottie from "lottie-react";
import { useNavigation } from "react-router";

import animation from "../../../../assets/animation/MZKc7dDskN.json";

import { useAppSelector } from "../../../../hook/useAppSelector";
import { useAppDispatch } from "../../../../hook/useAppDispatch";
import { closeModal } from "../../../../store/slice/health-monitor/modal";

const Loader: React.FC = () => {
  const isLoadingDeviceList = useAppSelector(
    (state) => state.deviceList.isLoadingDeviceList
  );
  const isLoadingSomeOfDeviceDetails = useAppSelector(
    (state) => state.deviceDetails.isLoadingSomeOfDeviceDetails
  );
  const navigation = useNavigation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (navigation.state === "loading") {
      dispatch(closeModal());
    }
  }, [navigation.state, dispatch]);

  return (
    <>
      {(isLoadingSomeOfDeviceDetails ||
        isLoadingDeviceList ||
        navigation.state === "loading") && (
        <div className="loader">
          <Lottie
            animationData={animation}
            loop={true}
            autoPlay={true}
            style={{ width: 300, height: 300, overflow: "hidden" }}
          ></Lottie>
        </div>
      )}
    </>
  );
};

export default Loader;
